import { useTranslations } from "@jti/ui";

import styles from "./SummaryCartItems.module.scss";

type SummaryCartItemsGiftBadge = {
  className?: string;
};

export const SummaryCartItemsGiftBadge = ({ className }: SummaryCartItemsGiftBadge) => {
  const { __ } = useTranslations();

  return (
    <div className={className ?? styles.badge} data-testid="summary-cart-items-gift-badge">
      <span>{__("cart.payment_summary.freeGift")}</span>
    </div>
  );
};
